import {Component, effect, inject, input} from '@angular/core'
import {BaseTable, BindingPipe, IWaitComponentData, WaitComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {InterestInput} from '../interest-input/interest-input'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table'
import {IInterestRow} from '../../../0-application/types'
import {MatDialog} from '@angular/material/dialog'

@Component({
  selector: 'spb-production-price-table',
  imports: [
    InterestInput,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatHeaderCellDef,
    BindingPipe
  ],
  templateUrl: './production-price-table.html',
  styleUrls: ['../../tables.scss', './production-price-table.scss']
})
export class ProductionPriceTable extends BaseTable<IInterestRow> {
  // The data.
  public interests = input.required<IInterestRow[]>()

  /**
   * We need:
   * 0-50, 50-55, 55-60, 60-65, 65-70, 70-75, 75-80, 80-85, 85-90, 90-100+
   0      1      2      3      4      5      6      7      8      9
   50:    55     60     65     70     75     80     85     90     100 (or rest)
   {50:  55:    60:   65:   70:   75:   80:   85    90:   100: 0}
   */
  public ltvs = ['50', '55', '60', '65', '70', '75', '80', '85', '90', '100']

  private readonly dialog = inject(MatDialog)

  constructor() {
    super()
    this.columns.set(['name', ...this.ltvs])

    effect(() => {
      this.items.data = this.interests()
    })
  }

  /**
   * We expect a matrix of 8 rows with ten columns. This may
   * or may not work. For any deviance we display a dialog
   * ask for a retry. The paste is set on the _table_ so no
   * matter where you paste we will treat it as a full
   * matrix.
   *
   * This is what you get in this iteration.
   *
   */
  public onPaste(data: any) {
    // Stop all other paste.
    data.preventDefault()
    const paste = data.clipboardData.getData('text')
    // The pasted data should consist of rows and columns
    // There should be exactly 8 rows 3m, 1y, 2y, 3y, 4y, 5y 7y and 10 years,
    //                                 1   2   3   4   5   6  7        8
    // But... Excel give us an extra empty row so we splice
    const rows: string[] = paste.split('\n').splice(0, 8)
    try {
      if (rows.length !== 8) {
        this.pasteError('Fel antal rader.')
      }

      const matrix = rows.map(row => {
        const columns = row.split('\t')
        // We need exactly 10 columns to populate our data.
        // else we risk to break.
        if (columns.length !== 10) {
          throw new Error('Fel antal kolumner i indata')
        }
        return columns.map(column => {
          // Most likely we get stuff like 3,23% replace all , with . and hope
          // that the number parse removes % and other shite.
          return Number.parseFloat(column.replaceAll(',', '.'))
        })
      })

      // Our interests is an array of objects. The array is easy we can iterate over it
      this.interests().forEach(row => {
        const matrixRow: number[] = matrix.shift()! // Steal the first row of the matrix

        // Now our "row" is an object, not an array so we map out all "items" of the
        // object and make those an array.
        Object.values(row.interests).forEach(interest => {
          // What you have now is one interest as a signal
          // For each, steal the first item of the matrix row and set that
          interest.set(matrixRow.shift())
        })
      })
    } catch (e: any) {
      this.pasteError(e.message)
    }
  }

  private pasteError(text: string) {
    this.dialog.open<WaitComponent, IWaitComponentData, void>(WaitComponent, {
      data: {
        title: 'Fel',
        text,
        closable: true
      }
    })
  }
}
